import { Alert, Button, Checkbox, Col, Descriptions, Form, Popconfirm } from "antd";
import { IRepairCase, IRepairCaseFetchingInfo, IRepairCaseInitialData, IRepairCaseProps, IRepairCaseStates, enmRepairCaseStatus, enmRepairationStatus, repairCaseStatusOptions, repairationStatusOptions, sendMethodsOptions } from "../../baseInfo/repairCase/interfaces";
import { BaseEntityManager } from "../../components/entityManager";
import { IMetadata, IProperty, enmControlType, enmEntityManagerState, enmPropertyType } from "../../components/entityManager/interfaces";
import AppContext from "../../components/infrastructure/appContext";
import { AttachmentViewer } from "../../baseInfo/attachment/attachmentViewer";
import dayjs from 'dayjs';
import { ICallOptions, IResult, IResultSet } from "../../components/infrastructure/models";
import { IRepairationActionProps } from "./interfaces";
import * as RepairationComponents from './components';
import React, { ReactNode } from "react";
import { Core } from "../../components/infrastructure/core";
import TextArea from "antd/lib/input/TextArea";
import { ColumnFilter } from "../../components/entityManager/columnfilter";
import { ICenterProps } from "../../baseInfo/center/interfaces";
import { Center } from "../../baseInfo/center";
import { ComparisonFilter, enmConditionalOperators } from "../../components/infrastructure/filtering";
import { IExcelColumn } from "antd-table-saveas-excel/app";
import { FileExcelOutlined, PrinterOutlined } from '@ant-design/icons';
import { Excel } from "antd-table-saveas-excel";
import { Payment } from "./components";
import { IProblem } from "../../baseInfo/problem/interfaces";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";

const ProblemsList = (props: { items: IProblem[] }) => {
    const list = props.items.map(item =>
        <Descriptions.Item key={item.Id} >
            <Checkbox checked >
                {item.Name}
            </Checkbox>
        </Descriptions.Item>);
    return (
        <Descriptions key="ProblemsList" layout='horizontal' column={{ xxl: 5, xl: 4, lg: 3, md: 2, sm: 2, xs: 1 }}>
            {list}
        </Descriptions>
    );
}

export class RepairCaseCenter extends BaseEntityManager<IRepairCase, IRepairCaseProps, IRepairCaseStates, IRepairCaseFetchingInfo, IRepairCaseInitialData>{
    static initMetadata = (): IMetadata => {
        return {
            title: "پرونده های تعمیرات (آزاد)",
            name: "RepairCaseCenter",
            Properties: [
                {
                    title: "شماره پیگیری",
                    dataIndex: "TicketNo",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    disabled: true,
                    filterable: true,
                    width: 150,
                    responsive: ['lg', 'md', 'sm', 'xs']
                },
                {
                    title: "شماره پرونده",
                    dataIndex: "Code",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    disabled: true,
                    filterable: true,
                    width: 150,
                    responsive: ['lg', 'md']
                },
                {
                    title: "وضعیت پرونده",
                    dataIndex: "Status",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: {
                        optionsFunc: () => repairCaseStatusOptions.map(o => {
                            if (o.value === enmRepairCaseStatus.Payment) {
                                return { title: 'منتظر دریافت مبلغ تعمیرات', value: o.value };
                            }
                            return { title: o.title, value: o.value };
                        })
                    },
                    disabled: true,
                    filterable: true,
                    width: 200,
                    responsive: ['lg', 'md', 'sm', 'xs']
                },
                {
                    title: "وضعیت تعمیرات",
                    dataIndex: "RepairationStatus",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: {
                        optionsFunc: () => repairationStatusOptions.map(o => {
                            return { title: o.centerCartableTitle, value: o.value, name: o.name };
                        })
                    },
                    disabled: true,
                    filterable: true,
                    sortable: false,
                    width: 200,
                    responsive: ['lg', 'md', 'sm']
                },
                {
                    title: "سریال یا IMEI دستگاه",
                    dataIndex: "CustomerEquipmentModel.EquipmentSerialNo",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    responsive: ['lg', 'md']
                },
                {
                    title: "کد ملی مشتری",
                    dataIndex: "CustomerEquipmentModel.Customer.NationalCode",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    responsive: ['lg', 'md', 'sm']
                },
                {
                    title: "مشتری",
                    dataIndex: "CustomerEquipmentModel.Customer.FullName",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.textbox,
                    filterable: false,
                    sortable: false,
                    width: 200,
                    responsive: ['lg', 'md']
                },
                {
                    title: "نوع تجهیز",
                    dataIndex: "CustomerEquipmentModel.Equipment.Name",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 120,
                    responsive: ['lg', 'md']
                },
                {
                    title: "برند",
                    dataIndex: "CustomerEquipmentModel.BrandTitle",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    sortable: true,
                    width: 120,
                    responsive: ['lg', 'md']
                },
                {
                    title: "مدل",
                    dataIndex: "CustomerEquipmentModel.EquipmentModelTitle",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    sortable: true,
                    width: 120,
                    responsive: ['lg', 'md']
                },
                {
                    title: "روش ارسال",
                    dataIndex: "SendMethod",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: {
                        optionsFunc: () => {
                            return sendMethodsOptions.map(a => {
                                return { name: a.name, title: a.name, value: a.value };
                            });
                        }
                    },
                    disabled: true,
                    filterable: true,
                    showColumn: false,
                    width: 150,
                    responsive: ['lg', 'md']
                },
                {
                    title: "تاریخ درخواست",
                    dataIndex: "CreateDateTime",
                    propertyType: enmPropertyType.date,
                    controlType: enmControlType.date,
                    disabled: true,
                    filterable: true,
                    width: 150,
                    responsive: ['lg', 'md']
                },
                {
                    title: "توضیحات",
                    dataIndex: "Description",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.template,
                    disabled: true,
                    filterable: false,
                    showColumn: false,
                    renderControl: (currentEntity: IRepairCase) => {
                        return <TextArea value={currentEntity?.Description} datatype="string" disabled />;
                    },
                    responsive: ['lg', 'md']
                },
                {
                    title: "شماره تماس مشتری",
                    dataIndex: "EmergencyCallNumber",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    disabled: true,
                    filterable: true,
                    showColumn: false,
                    width: 150,
                    responsive: ['lg', 'md']
                }
            ]
        };
    }
    static contextType = AppContext;
    private repairCenterFilterProp: IProperty = {
        dataIndex: "RepairCenter",
        controlType: enmControlType.lookup,
        propertyType: enmPropertyType.number,
        allowNull: true,
        title: "مرکز تعمیر",
        lookup: {
            lookupComponent: Center,
            lookupDisplayFields: ["FullName"],
            dropdownDisplayFields: ["FullName", "NationalCode"],
            lookupProperty: ""
        }
    }
    private repairCenterFilterValue?: number;
    private repairCenterFilterOperator?: enmConditionalOperators;

    private showArchivesFilterProp: IProperty = {
        dataIndex: "ShowArchives",
        controlType: enmControlType.checkbox,
        propertyType: enmPropertyType.boolean,
        allowNull: true,
        title: "پرونده های بایگانی؟"
    };
    private showArchivesFilterValue?: boolean = false;

    executingCommand?: string;
    onInitializing() {
        this.extraFormNodeMarginTop = 5;
        this.searchable = true;
        this.searchArea = {
            columnsPerRow: 2,
            onReset: () => {
                this.repairCenterFilterValue = undefined;
                this.repairCenterFilterOperator = 0;
                this.showArchivesFilterValue = false;
            }
        };

        this.onBack = () => {
            this.executingCommand = "";
        };

        this.viewButtonTitle = () => "مشاهده پرونده تعمیر";

        this.onDataFetching = (fetchingInfo, onViewMode) => {
            if (this.initialData?.Center?.Id === 1 && !!this.repairCenterFilterValue && this.repairCenterFilterOperator !== undefined) {
                fetchingInfo.RepairCenterFilter = new ComparisonFilter("RepairCenter.Id", this.repairCenterFilterOperator, this.repairCenterFilterValue);
            }
            else
                fetchingInfo.RepairCenterFilter = undefined;
            fetchingInfo.ShowArchives = this.showArchivesFilterValue;
            fetchingInfo.FetchingDetails = onViewMode;
        };

        this.onLoaded = (initialData: IRepairCaseInitialData) => {
            if (!this.searchArea)
                return;

            this.searchArea.render = () => {
                const extraFilters: React.ReactNode[] = [];
                if (initialData?.Center?.Id === 1) {
                    const { dataIndex, title } = this.repairCenterFilterProp;
                    const repairCenterFilterNode = (
                        <Form.Item name={dataIndex} key={dataIndex} label={title}>
                            <ColumnFilter
                                parent={this}
                                property={this.repairCenterFilterProp}
                                onChange={currentFilter => {
                                    this.repairCenterFilterValue = !!currentFilter?.value ? currentFilter.value["Id"] : undefined;
                                    this.repairCenterFilterOperator = currentFilter?.operator;
                                }}
                                preparelookupProps={(lookupProps: ICenterProps) => {
                                    lookupProps.isRepairCenter = true;
                                    return lookupProps;
                                }}
                            />
                        </Form.Item>
                    );
                    extraFilters.push(repairCenterFilterNode);
                }

                const { dataIndex, title } = this.showArchivesFilterProp;
                extraFilters.push(
                    <Form.Item name={dataIndex} key={dataIndex} label={title}>
                        <ColumnFilter
                            parent={this}
                            property={this.showArchivesFilterProp}
                            onChange={currentFilter => {
                                this.showArchivesFilterValue = currentFilter?.value;
                            }}
                            initialValue={{ value: false, operator: 0 }}
                        />
                    </Form.Item>
                );
                return extraFilters;
            };
        }

        this.renderingToolbar = () => {
            let result: ReactNode[] = [];
            let entity = this.selectedEntity!;
            const currentRepairCenter = entity.RepairCaseCenters[entity.RepairCaseCenters.length - 1];
            if (this.initialData) {
                if (this.initialData.AccessList["AssignCenter"] && entity.Status === enmRepairCaseStatus.AssignCenter) {
                    result.push(
                        <Col key="AssignCenter" style={{ marginLeft: 10 }}>
                            <Button key="AssignCenter" type="primary" onClick={this.handleCommand}>بررسی و ارسال به کارشناس</Button>
                        </Col>
                    );
                }
                else if (this.initialData.Center?.Id === currentRepairCenter?.RepairCenterId && entity.Status === enmRepairCaseStatus.Repairation) {
                    if (this.initialData.AccessList["RequestCheck"] && entity.RepairationStatus === enmRepairationStatus.RequestCheck) {
                        result.push(
                            <Col key="RequestCheck" style={{ marginLeft: 10 }}>
                                <Button key="RequestCheck" type="primary" onClick={this.handleCommand}>بررسی درخواست</Button>
                            </Col>
                        );
                    }
                    else if (this.initialData.AccessList["ReceiveDevice"] && entity.RepairationStatus === enmRepairationStatus.SendDevice) {
                        result.push(
                            <Col key="ReceiveDevice" style={{ marginLeft: 10 }}>
                                <Popconfirm okButtonProps={{ size: "middle" }} cancelButtonProps={{ size: "middle" }} okText="بلی" cancelText="خیر" title="آیا دریافت دستگاه مورد تأیید است؟"
                                    onConfirm={this.receiveDevice}>
                                    <Button key="ReceiveDevice" type="primary">دریافت دستگاه</Button>
                                </Popconfirm>
                            </Col>
                        );
                    }
                    else if (this.initialData.AccessList["Estimation"] && entity.RepairationStatus === enmRepairationStatus.Estimation) {
                        result.push(
                            <Col key="Estimation" style={{ marginLeft: 10 }}>
                                <Button key="Estimation" type="primary" onClick={this.handleCommand}>برآورد هزینه</Button>
                            </Col>
                        );
                    }
                    else if (this.initialData.AccessList["RepairationComplete"] && entity.RepairationStatus === enmRepairationStatus.RepairationComplete) {
                        result.push(
                            <Col key="RepairationComplete" style={{ marginLeft: 10 }}>
                                <Button key="RepairationComplete" type="primary" onClick={this.handleCommand}>ثبت نتیجه تعمیرات</Button>
                            </Col>
                        );
                    }
                }
                else if (this.initialData.Center?.Id === currentRepairCenter?.RepairCenterId && this.initialData.AccessList["Payment"] && entity.Status === enmRepairCaseStatus.Payment) {
                    result.push(
                        <Col key="Payment" style={{ marginLeft: 10 }}>
                            <Button key="Payment" type="primary" onClick={this.handleCommand}>دریافت مبلغ تعمیرات</Button>
                        </Col>
                    );
                }
                else if (this.initialData.Center?.Id === currentRepairCenter?.RepairCenterId && this.initialData.AccessList["ReturnDevice"] && entity.Status === enmRepairCaseStatus.ReturnDevice) {
                    result.push(
                        <Col key="ReturnDevice" style={{ marginLeft: 10 }}>
                            <Popconfirm okButtonProps={{ size: "middle" }} cancelButtonProps={{ size: "middle" }} okText="بلی" cancelText="خیر" title="آیا دستگاه به مشتری تحویل داده شود؟"
                                onConfirm={this.returnDevice}>
                                <Button key="ReturnDevice" type="primary">تحویل دستگاه به مشتری</Button>
                            </Popconfirm>
                        </Col>
                    );
                }
                else if (this.initialData.AccessList["Archive"] && [enmRepairCaseStatus.Completed, enmRepairCaseStatus.Rejected].indexOf(entity.Status) > -1) {
                    result.push(
                        <Col key="Archive" style={{ marginLeft: 10 }}>
                            <Popconfirm okButtonProps={{ size: "middle" }} cancelButtonProps={{ size: "middle" }} okText="بلی" cancelText="خیر" title="آیا پرونده بایگانی شود؟"
                                onConfirm={this.archive}>
                                <Button key="Archive" type="primary">بایگانی</Button>
                            </Popconfirm>
                        </Col>
                    );
                }
            }

            return result.length ? (<> {result} </>) : (<></>);
        }

        this.extraViewNode = () => {
            const { currentEntity, repairationSteps } = this.state;
            if (!currentEntity)
                return;

            let steps: React.ReactNode[] = [];

            if (currentEntity.RepairCaseAttachments.length || currentEntity.RepairCaseProblems.length) {
                steps.push(
                    <div key={"RepairCaseMoreInfo"} style={{ padding: "5px 0", pageBreakInside: "avoid" }}>
                        <div className="box box-blue" >
                            <div className="box-title">
                                <div className="caption">
                                    <Descriptions>
                                        <Descriptions.Item><b>اطلاعات بیشتر</b></Descriptions.Item>
                                        <Descriptions.Item label="تاریخ"><span style={{ direction: "ltr", float: "left" }}>{dayjs(currentEntity.CreateDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD HH:mm")}</span></Descriptions.Item>
                                        <Descriptions.Item label="کاربر">{currentEntity?.CustomerEquipmentModel.Customer.FullName}</Descriptions.Item>
                                    </Descriptions>
                                </div>
                            </div>
                            <div className="box-body form">
                                <div className="form-body">
                                    <div style={{ padding: 10 }}>

                                        {!!currentEntity.RepairCaseProblems.length &&
                                            <>
                                                <p>مشکل دستگاه:</p>
                                                <ProblemsList key={'RepairCaseProblems'} items={currentEntity.RepairCaseProblems.map(p => p.EquipmentProblem.Problem)} />
                                            </>
                                        }
                                        {!!currentEntity.RepairCaseAttachments.length &&
                                            <>
                                                <br />
                                                <AttachmentViewer key={'RepairCaseAttachments'} attachments={currentEntity.RepairCaseAttachments.filter(a => !a.Tag)} />
                                            </>
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }

            let repairCaseCenterId: number | undefined = undefined;
            currentEntity.RepairCaseCenters.forEach(repairCaseCenter => {
                if (repairCaseCenter.Id !== repairCaseCenterId) {
                    repairCaseCenterId = repairCaseCenter.Id;

                    steps.push(
                        <div key={(repairCaseCenter as any).RowGuid} style={{ padding: "5px 0", pageBreakInside: "avoid" }}>
                            <div className="box box-blue">
                                <div className="box-title">
                                    <div className="caption">
                                        <Descriptions>
                                            <Descriptions.Item><b>بررسی و تخصیص کارشناس تعمیر</b></Descriptions.Item>
                                            <Descriptions.Item label="تاریخ"><span style={{ direction: "ltr", float: "left" }}>{dayjs(repairCaseCenter.CreateDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD HH:mm")}</span></Descriptions.Item>
                                            <Descriptions.Item label="کاربر">{repairCaseCenter.Creator?.FullName ?? 'مدیر سیستم'}</Descriptions.Item>
                                        </Descriptions>
                                    </div>
                                </div>
                                <div className="box-body form">
                                    <div className="form-body">

                                        <RepairationComponents.AssignCenter
                                            repairCase={this.state.currentEntity!}
                                            repairCaseCenter={repairCaseCenter}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    );

                    repairationSteps.filter(s => s.RepairCaseCenterId === repairCaseCenterId)
                        .forEach((s, i) => {
                            let title = repairationStatusOptions.find(o => o.value === s.Substatus)?.name;

                            let repeatedStep = !!repairationSteps.find((v, vIndex) => v.Substatus === s.Substatus && i > vIndex);
                            if (repeatedStep)
                                title += ' (مجدد) ';
                            let dateTime = dayjs(s.CreateDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD HH:mm");
                            let history: React.ReactNode;
                            let formName = enmRepairationStatus[Number(s.Substatus)];
                            let formProps: IRepairationActionProps<any> = {
                                steps: repairationSteps,
                                entity: s,
                                disabled: true,
                                repairCase: this.state.currentEntity!,
                            };

                            const Component = (RepairationComponents as any)[formName];
                            if (Component) {

                                history = (
                                    <div>
                                        <Component key={s.RowGuid} {...formProps} />
                                    </div>
                                );

                                steps.push(
                                    <div key={s.RowGuid} style={{ padding: "5px 0", pageBreakInside: "avoid" }}>
                                        <div className="box box-blue">
                                            <div className="box-title">
                                                <div className="caption">
                                                    <Descriptions>
                                                        <Descriptions.Item><b>{title}</b></Descriptions.Item>
                                                        <Descriptions.Item label="تاریخ"><span style={{ direction: "ltr", float: "left" }}>{dateTime}</span></Descriptions.Item>
                                                        <Descriptions.Item label="کاربر">{s.Creator?.FullName}</Descriptions.Item>
                                                    </Descriptions>
                                                </div>
                                            </div>
                                            <div className="box-body form">
                                                <div className="form-body">
                                                    {history}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                        });
                }
            });

            if (this.executingCommand) {
                let formProps: IRepairationActionProps<any> = {
                    steps: repairationSteps,
                    onClose: () => {
                        this.back();
                    },
                    onSubmit: async ({ data, url, contentType, headers, completeCallback }) => {
                        let fetchOpt: ICallOptions = {
                            url,
                            data,
                            contentType,
                            headers,
                            onSuccess: async (result: IResultSet<any>) => {
                                completeCallback(result);
                                if (result.ValidationState.Successful)
                                    await this.fetchData();
                            }
                        };
                        await this.callApi(fetchOpt);
                    },
                    repairCase: this.state.currentEntity!,
                };
                const Component = (RepairationComponents as any)[this.executingCommand];
                if (Component) {
                    let title = this.executingCommand === "AssignCenter" ?
                        repairCaseStatusOptions.find(o => enmRepairCaseStatus[Number(o.value)] === this.executingCommand)?.title :
                        repairationStatusOptions.find(o => enmRepairationStatus[Number(o.value)] === this.executingCommand)?.name;

                    const action = (
                        <div style={{ padding: 20 }} ref={node => {
                            if (!!node && this.state.state === enmEntityManagerState.View) {
                                node.scrollIntoView({ behavior: "smooth" });
                            }
                        }}>
                            <Component key={this.executingCommand} {...formProps} />
                        </div>
                    );

                    steps.push(
                        <div key={this.executingCommand} style={{ padding: "5px 0", pageBreakInside: "avoid" }}>
                            <div className="box box-blue">
                                <div className="box-title">
                                    <div className="caption">
                                        <Descriptions>
                                            <Descriptions.Item><b>{title}</b></Descriptions.Item>
                                        </Descriptions>
                                    </div>
                                </div>
                                <div className="box-body form">
                                    <div className="form-body">
                                        {action}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                }
            }
            else {
                if (currentEntity.Paid === true) {
                    const action = (
                        <div style={{ padding: 20 }} ref={node => {
                            if (!!node && this.state.state === enmEntityManagerState.View) {
                                node.scrollIntoView({ behavior: "smooth" });
                            }
                        }}>
                            <Payment key={"Payment"}
                                steps={steps}
                                repairCase={currentEntity}
                                disabled
                                entity={{
                                    RepairCaseId: currentEntity.Id,
                                    PaymentReceiptDateTime: !!currentEntity.PaymentReceiptDateTime ? dayjs(new Date(currentEntity.PaymentReceiptDateTime)).calendar('jalali') : undefined,
                                    PaymentReceipts: currentEntity.RepairCaseAttachments.filter(a => !!a.Tag)
                                }} />
                        </div>
                    );

                    steps.push(
                        <div key={"Payment"} style={{ padding: "5px 0", pageBreakInside: "avoid" }}>
                            <div className="box box-blue" >
                                <div className="box-title">
                                    <div className="caption">
                                        <Descriptions>
                                            <Descriptions.Item><b>دریافت مبلغ تعمیرات</b></Descriptions.Item>
                                        </Descriptions>
                                    </div>
                                </div>
                                <div className="box-body form">
                                    <div className="form-body">
                                        {action}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );

                    let returnDate = !!currentEntity.PaymentReceiptDateTime
                        ? dayjs(currentEntity.PaymentReceiptDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD")
                        : dayjs(currentEntity.CreateDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD");

                    const messageNode = (
                        <div style={{ lineHeight: 2.2 }}>
                            <b>
                                هزینه تعمیرات در تاریخ <b>{returnDate}</b> دریافت شد
                            </b>
                        </div>
                    );
                    const msg = (
                        <div key={"PaymentMessage"} style={{ padding: "5px 0" }}>
                            <div className="box" >
                                <div style={{ direction: "rtl" }}>
                                    <Alert type="info" message={messageNode} />
                                </div>
                            </div>
                        </div>
                    );
                    steps.push(msg);
                }

                if (currentEntity.DeviceReturned === true) {
                    let returnDate = dayjs(currentEntity.DeviceReturnedDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD");
                    const messageNode = (
                        <div style={{ lineHeight: 2.2 }}>
                            <b>
                                دستگاه در تاریخ <b>{returnDate}</b> به مشتری تحویل داده شد
                            </b>
                        </div>
                    );
                    const msg = (
                        <div key={"DeviceReturnedMessage"} style={{ padding: "5px 0" }}>
                            <div className="box" >
                                <div style={{ direction: "rtl" }}>
                                    <Alert type="info" message={messageNode} />
                                </div>
                            </div>
                        </div>
                    );
                    steps.push(msg);
                }

                if (currentEntity.Status === enmRepairCaseStatus.Archived) {
                    const messageNode = (
                        <div style={{ lineHeight: 2.2 }}>
                            <b>
                                درخواست بسته شد
                            </b>
                        </div>
                    );
                    const msg = (
                        <div key={"ClosedMessage"} style={{ padding: "5px 0" }}>
                            <div className="box" >
                                <div style={{ direction: "rtl" }}>
                                    <Alert type="info" message={messageNode} />
                                </div>
                            </div>
                        </div>
                    );
                    steps.push(msg);
                }
            }

            return (
                <>
                    {steps}
                </>
            );
        };

        this.extraHeaderButtons = () => {
            let buttons: React.ReactNode[] = [];
            if (this.initialData && this.initialData.AccessList["ExportToExcel"]) {
                buttons.push(
                    <Button key="ExportToExcel" type="primary" onClick={this.exportToExcel} icon={<FileExcelOutlined />}>اکسل</Button>
                );
            }
            if (this.state.state === enmEntityManagerState.View) {
                buttons.push(
                    <ReactToPrint key="printRepairCase" content={() => this.viewRef ?? null} >
                        <PrintContextConsumer>
                            {({ handlePrint }) => (
                                <Button key="printRepairCase"
                                    icon={<PrinterOutlined />}
                                    style={{ lineHeight: '0.5em', verticalAlign: 'middle', width: '140px', marginRight: 10 }}
                                    type="default"
                                    onClick={handlePrint}>
                                    چاپ پرونده
                                </Button>
                            )}
                        </PrintContextConsumer>
                    </ReactToPrint>
                );
            }
            return buttons;
        };
    }

    handleCommand = async () => {
        const { selectedEntity } = this;
        if (!selectedEntity)
            return;

        if (selectedEntity.Status === enmRepairCaseStatus.AssignCenter)
            this.executingCommand = "AssignCenter";
        else if (selectedEntity.Status === enmRepairCaseStatus.Payment)
            this.executingCommand = "Payment";
        else
            this.executingCommand = enmRepairationStatus[Number(selectedEntity.RepairationStatus)];

        await this.view(selectedEntity.RowGuid);
    }
    receiveDevice = async () => {
        const { selectedEntity } = this;
        if (!selectedEntity)
            return;

        let fetchOpt: ICallOptions = {
            url: "repaircasecenter/receivedevice",
            data: { repairCaseId: selectedEntity.Id, rowVrsn: selectedEntity.RowVrsn },
            onSuccess: async (result: IResultSet<any>) => {
                if (result.ValidationState.Successful) {
                    Core.successNotification("دستگاه با موفقیت دریافت شد");
                    await this.fetchData();
                }
            },
            onError: () => {

            }
        };
        await this.callApi(fetchOpt);
    }
    payment = async () => {
        const { selectedEntity } = this;
        if (!selectedEntity)
            return;

        let fetchOpt: ICallOptions = {
            url: "repaircasecenter/payment",
            data: { repairCaseId: selectedEntity.Id, rowVrsn: selectedEntity.RowVrsn },
            onSuccess: async (result: IResultSet<any>) => {
                if (result.ValidationState.Successful) {
                    Core.successNotification("هزینه تعمیرات با موفقیت پرداخت شد");
                    await this.fetchData();
                }
            },
            onError: () => {

            }
        };
        await this.callApi(fetchOpt);
    }
    returnDevice = async () => {
        const { selectedEntity } = this;
        if (!selectedEntity)
            return;

        let fetchOpt: ICallOptions = {
            url: "repaircasecenter/returndevice",
            data: { repairCaseId: selectedEntity.Id, rowVrsn: selectedEntity.RowVrsn },
            onSuccess: async (result: IResult) => {
                if (result.ValidationState.Successful) {
                    Core.successNotification("دستگاه با موفقیت تحویل مشتری شد");
                    await this.fetchData();
                }
            },
            onError: () => {

            }
        };
        await this.callApi(fetchOpt);
    }
    archive = async () => {
        const { selectedEntity } = this;
        if (!selectedEntity)
            return;

        let fetchOpt: ICallOptions = {
            url: "repaircasecenter/archive",
            data: { repairCaseId: selectedEntity.Id, rowVrsn: selectedEntity.RowVrsn },
            onSuccess: async (result: IResult) => {
                if (result.ValidationState.Successful) {
                    Core.successNotification("پرونده بایگانی شد");
                    await this.fetchData();
                }
            },
            onError: () => {

            }
        };
        await this.callApi(fetchOpt);
    }
    onEntityView = (entity: IRepairCase) => {
        let fetchOpt: ICallOptions = {
            url: "repaircasecenter/getallrepairationsteps",
            data: { repairCaseId: entity.Id },
            onSuccess: (result: IResultSet<any>) => {
                this.setState({ state: enmEntityManagerState.View, currentEntity: entity, repairationSteps: result.Data.steps });
            },
            onError: () => {

            }
        };
        this.callApi(fetchOpt);
        return false;
    }
    getExcelColumns = (): IExcelColumn[] => {
        return [
            {
                dataIndex: 'TicketNo',
                title: 'شماره پیگیری',
                width: 200,
            },
            {
                dataIndex: 'Code',
                title: 'شماره پرونده',
                width: 200,
            },
            {
                dataIndex: 'CustomerNationalCode',
                title: 'کد ملی مشتری',
                width: 200,
            },
            {
                dataIndex: 'CustomerFullName',
                title: 'نام و نام خانوادگی مشتری',
                width: 200,
            },
            {
                dataIndex: 'EquipmentName',
                title: 'دستگاه/تجهیز',
                width: 200,
            },
            {
                dataIndex: 'BrandName',
                title: 'برند',
                width: 200,
            },
            {
                dataIndex: 'EquipmentModelName',
                title: 'مدل',
                width: 200,
            },
            {
                dataIndex: 'Status',
                title: 'وضعیت پرونده',
                width: 200,
                render: (_, record) => {
                    return repairCaseStatusOptions.find(s => s.value === record.Status)?.title;
                }
            },
            {
                dataIndex: 'RepairationStatus',
                title: 'وضعیت تعمیر',
                width: 200,
                render: (_, record) => {
                    return repairationStatusOptions.find(s => s.value === record.RepairationStatus)?.name;
                }
            },
            {
                dataIndex: 'ProvinceName',
                title: 'استان',
                width: 200,
            },
            {
                dataIndex: 'CityName',
                title: 'شهر',
                width: 200,
            },
            {
                dataIndex: 'Problems',
                title: 'مشکلات',
                width: 200,
            },
            {
                dataIndex: 'CustomerDescription',
                title: 'توضیحات مشتری',
                width: 200,
            },
            {
                dataIndex: 'SendMethod',
                title: 'نحوه ارسال دستگاه',
                width: 200,
                render: (_, record) => {
                    return sendMethodsOptions.find(s => s.value === record.SendMethod)?.name;
                }
            },
            {
                dataIndex: 'AdminDescription',
                title: 'توضیحات مدیر سیستم',
                width: 200,
            },
            {
                dataIndex: 'SentToRepairCenterDateTime',
                title: 'تاریخه ارسال به کارشناس',
                width: 200,
                render: (_, record) => {
                    return !!record.SentToRepairCenterDateTime ? dayjs(record.SentToRepairCenterDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD HH:mm") : '';
                }
            },
            {
                dataIndex: 'ExpertRejectDescription',
                title: 'علت رد درخواست توسط کارشناس',
                width: 200,
            },
            {
                dataIndex: 'EstimationExpertFullName',
                title: 'نام کارشناس',
                width: 200,
            },
            {
                dataIndex: 'EstimationDateTime',
                title: 'تاریخ برآورد هزینه',
                width: 200,
                render: (_, record) => {
                    return !!record.EstimationDateTime ? dayjs(record.EstimationDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD HH:mm") : '';
                }
            },
            {
                dataIndex: 'EstimatedAmount',
                title: 'مبلغ برآورد هزینه',
                width: 200,
            },
            {
                dataIndex: 'ExpertFullName',
                title: 'نام تعمیرکار',
                width: 200,
            },
            {
                dataIndex: 'RepairationCompleteDateTime',
                title: 'تاریخ پایان تعمیرات',
                width: 200,
                render: (_, record) => {
                    return !!record.RepairationCompleteDateTime ? dayjs(record.RepairationCompleteDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD HH:mm") : null;
                }
            },
            {
                dataIndex: 'PayableAmount',
                title: 'مبلغ هزینه تعمیرات',
                width: 200,
            },
            {
                dataIndex: 'DeviceReceivedDateTime',
                title: 'تاریخ دریافت دستگاه از مشتری',
                width: 200,
                render: (_, record) => {
                    return !!record.DeviceReceivedDateTime ? dayjs(record.DeviceReceivedDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD HH:mm") : null;
                }
            },
            {
                dataIndex: 'DeviceReturnedDateTime',
                title: 'تاریخ تحویل دستگاه به مشتری',
                width: 200,
                render: (_, record) => {
                    return !!record.DeviceReturnedDateTime ? dayjs(record.DeviceReturnedDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD HH:mm") : null;
                }
            },
            {
                dataIndex: 'PaymentDateTime',
                title: 'تاریخ پرداخت',
                width: 200,
                render: (_, record) => {
                    return !!record.PaymentDateTime ? dayjs(record.PaymentDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD HH:mm") : null;
                }
            }
        ];
    }
    exportToExcel = async () => {

        let fetchingInfo = this.getCurrentFetchingInfo();

        let fetchOpt: ICallOptions = {
            url: "repaircasecenter/exporttoexcel",
            data: { fetchingInfo },
            onSuccess: (result: IResultSet<any>) => {
                if (result.ValidationState.Successful) {
                    const data = result.Data as [];
                    if (!data.length) {
                        Core.warningNotification('اطلاعاتی یافت نشد');
                        return;
                    }
                    const columns = this.getExcelColumns();
                    const excel = new Excel();
                    excel
                        .addSheet(this.title)
                        .addColumns(columns)
                        .addDataSource(result.Data, {
                            str2Percent: true
                        })
                        .saveAs(this.title + ".xlsx");

                }
            },
            onError: () => {

            }
        };
        await this.callApi(fetchOpt);
    }
}